





























import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountLendingCardSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/Cards/AccountLendingCardSettings';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingCardSettingsRead' })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountLendingCardSettings;

}
